import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import ModalComponent from  '../../../components/ModalComponent';
import {FaDonate, FaSearch} from "react-icons/fa";
import {Button, Card, CardBody, Input, InputGroup, InputGroupAddon, Table} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../../components/PaginateComponent";
import ListPaymentAllComponent from "../../../components/Admin/payments/ListPaymentAllComponent";


class ListPaymentAllPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listPayment: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            userId: 0,
            typeOrder: '',
            qtt: 20,
            maGd: '',
            typePayment: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListPayment();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListPayment = () => {
        this.setState({
            isLoading: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?qtt=" + this.state.qtt + "&maGd=" + this.state.maGd  + "&typePayment=" + this.state.typePayment;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/payment/getListPaymentAll' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listPayment: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    screentListPayment = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listPayment.length ) {
                return (
                    this.state.listPayment.map( (payment, key) => {
                        return (
                            <ListPaymentAllComponent
                                key={key}
                                payment={payment}
                                actionKey={key}
                                showModal = { (actionKey, action) => this.showModal(actionKey, action) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có đơn hàng trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            qtt: value
        })
        await this.getListPayment();
    }

    changeTypePayment = async (event) => {
        let value = event.target.value;
        await this.setState({
            typePayment: value
        })
        await this.getListPayment();
    }

    search = (event) => {
        // console.log(event.target.value)
        this.setState({
            maGd: event.target.value
        })
    }

    submitSearch = (event) => {
        if(event.key === 'Enter') {
            this.getListPayment();
        }
    }

    btnSearch = () => {
        this.getListPayment();
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?qtt=" + this.state.qtt + "&maGd=" + this.state.maGd
            + "&typePayment=" + this.state.typePayment + "&page=" + page;
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/payment/getListPaymentAll' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listPayment: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        isLoading: false
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                })
            })
    }

    showModal = (actionKey, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'delete' ) {
            titleModal = 'Xóa giao dịch nạp tiền';
            modalBody = this.modalBody(actionKey, action);
        }
        else if ( action === 'confirm' ) {
            titleModal = 'Xác nhận giao dịch nạp tiền';
            modalBody = this.modalBody(actionKey, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: actionKey
        })
    }

    hiddenModal = () => {
        this.setState({
            actionKey: 0,
            action: '',
            isModal: false,
        })
    }

    modalBody = (actionKey, action) => {
        if ( action === 'delete' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa giao dịch có mã <b className="text-danger">{ this.state.listPayment[actionKey].ma_gd }</b> này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về giao dịch này. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
        else if ( action === 'confirm' ) {
            if (this.state.listPayment[actionKey].type !== 0) {
                return (
                    <div className="text-center">
                        Bạn có muốn xác nhận giao dịch có mã <b
                        className="text-danger">{this.state.listPayment[actionKey].ma_gd}</b> này không? <br/>
                        <span className="text-danger">
                        <b>Lưu ý: </b>
                            {this.textNote(actionKey)}
                    </span>
                    </div>
                )
            }
        }
    }

    textNote = (actionKey) => {
        if (this.state.listPayment[actionKey].type === 1) {
            return (
                <>
                    Hành động này xác nhận giao dịch đã thanh toán và cộng tiền vào tài khoản của khách hàng. Vui lòng kiểm tra lại.
                </>
            )
        }
        else if (this.state.listPayment[actionKey].type === 21 || this.state.listPayment[actionKey].type === 22 || this.state.listPayment[actionKey].type === 23) {
            return (
                <>
                    Hành động này xác nhận giao dịch đã thanh toán và tạo dịch vụ cho khách hàng. Vui lòng kiểm tra lại.
                </>
            )
        }
        else if (this.state.listPayment[actionKey].type === 31 || this.state.listPayment[actionKey].type === 32 || this.state.listPayment[actionKey].type === 33) {
            return (
                <>
                    Hành động này xác nhận giao dịch đã thanh toán và gia hạn dịch vụ của khách hàng. Vui lòng kiểm tra lại.
                </>
            )
        }
        else if (this.state.listPayment[actionKey].type === 41 || this.state.listPayment[actionKey].type === 42 || this.state.listPayment[actionKey].type === 43) {
            return (
                <>
                    Hành động này xác nhận giao dịch đã thanh toán và nâng cấp dịch vụ cho khách hàng. Vui lòng kiểm tra lại.
                </>
            )
        }
    }

    confirmModal = () => {
        this.setState({
            btnConfirmDisabled: true,
            isSpinner: true,
            isBtnConfirm: false,
        })

        let form = {
            paymentId: this.state.listPayment[this.state.actionKey].id,
            action: this.state.action,
        };
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.put( process.env.REACT_APP_API_URL + '/api/admin/payment/action', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isSpinner: false,
                });
                if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                    this.props.logOut();
                } else {
                    this.getListPayment();
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title
                        },
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                    },
                })
            })
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Tất cả giao dịch"} page={"Thanh toán"} icon={<FaDonate className="breadcrumb-icon"/>} />
                            <Card>
                                <CardBody>
                                    {
                                        this.state.error ? (
                                            <Alert color="danger">
                                                {this.state.messageError}
                                            </Alert>
                                        ) : (
                                            <div className="dataTables_wrapper dt-bootstrap">
                                                <div className="row">
                                                    <div className="col-md-3 mb-3 form-inline">
                                                        <select className="form-control form-control-sm mr-1" value={this.state.qtt} onChange={ this.changeQtt }>
                                                            <option value="10">10</option>
                                                            <option value="20">20</option>
                                                            <option value="30">30</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="200">200</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                    </div>
                                                    <div className="col-md-3">
                                                        <select className="form-control mr-1" value={this.state.typePayment} onChange={ this.changeTypePayment }>
                                                            <option value="" disabled={true}>Chọn loại giao dịch</option>
                                                            <option value="all">Tất cả</option>
                                                            <option value="create">Tạo dịch vụ</option>
                                                            <option value="expire">Gia hạn</option>
                                                            <option value="upgrade">Nâng cấp</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <InputGroup>
                                                            <Input placeholder="Tìm kiếm giao dịch" onChange={ this.search } onKeyPress={ this.submitSearch } />
                                                            <InputGroupAddon addonType="prepend">
                                                                <Button onClick={ () => this.btnSearch() }> <FaSearch /> </Button>
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </div>
                                                    <div className="col-md-12">
                                                        {
                                                            this.checkNotification()
                                                        }
                                                    </div>
                                                    <div className="col col-md-12 table-responsive">
                                                        <Table className="table-sm table-bordered table-hover rounded table-list">
                                                            <thead className="primary">
                                                                <tr>
                                                                    <th>Mã giao dịch</th>
                                                                    <th>Khách hàng</th>
                                                                    <th>Loại</th>
                                                                    <th>Số tiền</th>
                                                                    <th>Ngày giao dịch</th>
                                                                    <th>Ngày thanh toán</th>
                                                                    <th>Số dư trước</th>
                                                                    <th>Số dư sau</th>
                                                                    <th>Trạng thái</th>
                                                                    <th>Hành động</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                { this.screentListPayment() }
                                                            </tbody>
                                                            <tfoot className="mt-3">
                                                                <tr>
                                                                    <td colSpan={15}>
                                                                        { this.paginate() }
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminPaymentAll' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListPaymentAllPage);